<template>
  <DialogTemplate :is-open="isOpen" class="DialogTemplateArea" @click-mask="onClickMask">
    <div class="confirmContent" :class="{ isPc: !isSp, wideContentsWidth: wideContentsWidth }">
      <div class="text" :class="[fontSize, { isPc: !isSp, fontBold: fontBold }]" v-text="text" />
      <div class="choicesArea" :class="{ isPc: !isSp }">
        <ButtonTypeCustom
          button-type="button"
          :button-text="negativeCustomText"
          button-color="colorCancel"
          button-size="sizeLarge"
          class="negativeButton"
          @button-clicked="onClickNegative"
        />
        <ButtonTypeCustom
          button-type="button"
          :button-text="positiveCustomText"
          button-color="colorPrimary"
          button-size="sizeLarge"
          @button-clicked="onClickPositive"
        />
      </div>
    </div>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from './DialogTemplate.vue';
import ButtonTypeCustom from '../Button/ButtonTypeCustom.vue';

export default {
  name: 'Confirm',
  components: {
    DialogTemplate,
    ButtonTypeCustom,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    /**
     * テキスト
     * 改行文字改行しますが、『text="sample"』形式だと改行文字効かないので、『:text="'sample'"』で送ってください
     */
    text: {
      type: String,
      required: true,
    },
    fontBold: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * OKカスタムテキスト
     * 入力なければOKのまま
     */
    positiveCustomText: {
      type: String,
      required: false,
      default: 'OK',
    },
    /**
     * キャンセルカスタムテキスト
     * 入力なければOKのまま
     */
    negativeCustomText: {
      type: String,
      required: false,
      default: 'キャンセル',
    },
    /**
     * 永続オプション
     * trueの場合はMaskクリックで消えない
     * falseの場合はMaskクリックで消える、返却はfalse
     * confirmにおいて選択しなくてけて良いのはレアケースのため、デフォルトtrue
     */
    persistent: {
      type: Boolean,
      required: false,
      default: true,
    },
    isSpFlg: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    wideContentsWidth: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    fontSize: {
      required: false,
      default: 'paragraph1',
      validator(value) {
        return ['paragraph1', 'paragraph2'].indexOf(value) !== -1;
      },
    },
  },
  computed: {
    isSp() {
      if (typeof this.isSpFlg === 'boolean') return this.isSpFlg;
      return this.$isSp;
    },
  },
  methods: {
    onClickMask() {
      if (!this.persistent) {
        this.$emit('close-dialog', false);
      }
    },
    onClickNegative() {
      this.$emit('close-dialog', false);
    },
    onClickPositive() {
      this.$emit('close-dialog', true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

.confirmContent {
  &.isPc {
    width: 320px;

    &.wideContentsWidth {
      width: 396px;
    }
  }

  .text {
    white-space: pre-wrap;
    text-align: center;
    margin: 12px 0 32px;

    &.isPc {
      margin-top: 20px;
    }

    line-height: $text-line-height-default;

    &.fontBold {
      font-weight: $text-weight-bold;
    }

    &.paragraph1 {
      font-size: $text-size-paragraph1;
    }

    &.paragraph2 {
      font-size: $text-size-paragraph2;
    }
  }

  .choicesArea {
    display: flex;

    .negativeButton {
      margin-right: 8px;

      &.isPc {
        margin-right: 16px;
      }
    }

    &.isPc {
      margin-bottom: 20px;
    }
  }
}
</style>
